<template>
  <div class="full-width">
    <dropdown-timetable :pageId="page.id" @updateTimetable="updateTimetable" />
    <page-objects-container style="padding-bottom: 70px !important;" />
    <reservation-type-buttons-page :buttons="buttons" @startReservation="startReservation" />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { reservationTypes } from '@/config'
import routeNames from '@/router/routes'

const { EXTERNAL_RESERVATION_SYSTEM } = reservationTypes

export default {
  data () {
    return {
      timetable: null,
    }
  },
  created () {
    if (this.authStatus) {
      this.$store.dispatch('me/getBookings')
    }
    this.$store.commit('cart/resetCart')
  },
  methods: {
    updateTimetable (timetable) {
      this.timetable = timetable
    },
    startReservation (reservationMethod) {
      if (!this.activeReservationMethodsAvailable) return
      if (!this.authStatus && !reservationMethod.externalReservationSystemUrl) {
        const { path } = this.$route
        this.$router.push({ name: routeNames.login.name, query: { ['next-url']: path } })

      } else {
        if (reservationMethod.type === EXTERNAL_RESERVATION_SYSTEM) {
          const systemUrl = reservationMethod.externalReservationSystemUrl
          const pageId = `page-id=${ encodeURIComponent(this.page.id) }`
          let url = `${ systemUrl }?${ pageId }`
          if (this.authStatus) {
            const xApiKey = `x-api-key=${ encodeURIComponent(this.authToken) }`
            url += `&${ xApiKey }`
          }

          window.open(url, '_blank')
        } else {
          this.$store.commit('activityReservations/reset')
          localStorage.setItem('reservationMethodType', reservationMethod.type)
          this.$router.push({ name: routeNames.reservationCommonData.name })
        }
      }
    },
  },
  computed: {
    ...mapGetters({ 
      authStatus: 'auth/authStatus',
      authToken: 'auth/authToken',
    }),
    ...mapState({
      page: state => state.pages.page,
    }),
    reservationMethods () {
      return this.page && this.page.reservationMethods ? this.page.reservationMethods : []
    },
    activeReservationMethods () {
      return this.reservationMethods.filter(({ active }) => active)
    },
    activeReservationMethodsAvailable () {
      return this.activeReservationMethods.filter(({ type }) => {
        return true
      })
    },
    buttons () {
      if (!this.activeReservationMethodsAvailable) return []
      return this.activeReservationMethodsAvailable.map((reservationMethod) => {
        return { id: reservationMethod.id, reservationMethod }
      })
    },
  },
  components: {
    DropdownTimetable: () => import('@/components/view-components/webapp-pages/page-objects/DropdownTimetable.vue'),
    ReservationTypeButtonsPage: () => import('@/components/view-components/webapp-pages/ReservationTypeButtonsPage.vue'),
    PageObjectsContainer: () => import('@/components/view-components/webapp-pages/page-objects/PageObjectsContainer.vue'),
  },
}
</script>
